/* eslint-disable no-console */
import React, { FC, useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { useSelector } from 'react-redux'

import Main from './Main'

import { iRootState } from 'src/store'
import * as routes from 'src/constants/routes'
import { City } from 'src/store/models/user'
import Layout from 'src/components/Layout/Layout'

const stateSelector = (state: iRootState) => ({
  id: state.user.data?.id,
  profileComplete: state.user.data?.profileComplete,
  isAuthResolved: state.user.isAuthResolved,
})

const Profile: FC = () => {
  const { push } = useHistory()

  const { id, isAuthResolved, profileComplete } = useSelector(stateSelector)

  const [prevCity, setPrevCity] = useState<City | undefined>()

  useEffect(() => {
    if (isAuthResolved && id) {
      if (!profileComplete) {
        push(routes.SIGN_UP)
      }
      setPrevCity(prevCity)
    }
    if (isAuthResolved && !id) {
      console.log('wrong used id or token')
      push(routes.LANDING)
    }
  }, [push, id, isAuthResolved, prevCity, profileComplete])

  return (
    <Layout>
      <Main prevCity={prevCity} />
    </Layout>
  )
}

export default Profile
